<template>
  <div class="input" :class="wrapperClasses">
    <BaseLabel
      v-if="label"
      :id="id"
      :number="number"
      :label="label"
      :label-description="labelDescription"
      :required="required"
      :help="help"
      :class="labelClasses"
    />
    <div :class="controlClasses">
      <component
        :is="typeaheadComponent"
        :id="id"
        v-model="text"
        :error="error"
        :disabled="disabled"
        :min-length="minLength"
        :auto-select="autoSelect"
        :select-first="selectFirst"
        :options="options"
        :url="url"
        :api="api"
        :api-method="apiMethod"
        :on-input-change="onInputChange"
        :get-list-text="getListText"
        @input="$emit('input', $event)"
        @update:value="$emit('update:value', $event)"
        @update:item="$emit('update:item', $event)"
      />
    </div>
    <div v-if="description || error" :class="descriptionClasses">
      <BaseControlDescription :id="id" :description="description" />
      <BaseControlError :id="id" :error="error" />
    </div>
  </div>
</template>

<script>
import BaseFormControl from "@/components/Base/Form/BaseFormControl";
import BaseTypeAhead from "@/components/Base/Controls/BaseTypeAhead";
import BaseAjaxTypeAhead from "@/components/Base/Controls/BaseAjaxTypeAhead";

export default {
  name: "TypeAheadControl",
  components: {
    BaseTypeAhead,
    BaseAjaxTypeAhead
  },
  extends: BaseFormControl,
  props: {
    autoSelect: {
      type: Boolean,
      defualt: false
    },
    selectFirst: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    minLength: {
      type: Number,
      default: 3
    },
    onInputChange: {
      type: Function,
      default: undefined
    },
    api: {
      type: Object,
      default: null
    },
    apiMethod: {
      type: String,
      default: "getList"
    },
    getListText: {
      type: Function,
      default: item => item.name
    }
  },
  data() {
    return {
      text: this.value,
      typeaheadComponent: "BaseTypeAhead"
    };
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue != oldValue) {
        this.text = newValue;
      }
    }
  }
};
</script>
